import { FC } from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

export const HomeRealWorldExample: FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        py: { xs: 8, md: 10 },
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 4, md: 6 }} alignItems="center">
          <Grid item xs={12} md={5}>
            <Typography
              variant="overline"
              sx={{
                color: theme.palette.text.secondary,
                letterSpacing: "0.08em",
              }}
            >
              {t("Real-world example")}
            </Typography>
            <Typography
              component="h2"
              variant="h4"
              sx={{
                mt: 1,
                mb: 2,
                fontWeight: 700,
                color: theme.palette.text.primary,
                lineHeight: 1.2,
              }}
            >
              {t("AndroidAPS in everyday use")}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.secondary,
                lineHeight: 1.7,
                maxWidth: 520,
              }}
            >
              {t(
                "AndroidAPS screenshot displaying continuous glucose monitoring data alongside calculated insulin on board, pump insulin and battery level, carbs on board and current loop status."
              )}
              <br />
              <br />
              {t(
                "Users can use trend analysis, prediction algorithms, and dosing recommendations for a hybrid closed loop or choose to configure the loop to run as a fully closed loop."
              )}
            </Typography>
          </Grid>

          <Grid item xs={12} md={7}>
            <Box
              sx={{
                p: { xs: 0.75, sm: 1 },
                borderRadius: 2,
                border: `1px solid ${theme.palette.divider}`,
                boxShadow: "none",
                backgroundColor: theme.palette.background.default,
                maxWidth: 420,
                mx: "auto",
              }}
            >
              <Box
                component="img"
                src="/assets/screenshotAAPS.png"
                alt="AndroidAPS screen showing glucose trend and loop activity"
                loading="lazy"
                sx={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  borderRadius: 2,
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
